import { Controller } from "@hotwired/stimulus"

export default class ContactsController extends Controller {
  static targets = ["contactsContainer"]
  static values = { inputClasses: String }

  connect() {

  }

  addContact(event) {
    event.preventDefault();

    const contactDiv = document.createElement("div");
    contactDiv.classList.add("flex", "space-x-2", "mb-2");

    const nameInput = document.createElement("input");
    nameInput.type = "text";
    nameInput.placeholder = "Name";
    nameInput.className = this.inputClassesValue;

    const contactInput = document.createElement("input");
    contactInput.type = "text";
    contactInput.placeholder = "Contact";
    contactInput.className = this.inputClassesValue;

    const deleteButton = document.createElement("button");
    deleteButton.textContent = "X";
    deleteButton.classList.add("bg-red-400", "text-white", "px-2", "py-1", "rounded");
    deleteButton.addEventListener("click", () => contactDiv.remove());

    contactDiv.appendChild(nameInput);
    contactDiv.appendChild(contactInput);
    contactDiv.appendChild(deleteButton);

    this.contactsContainerTarget.appendChild(contactDiv);
  }
}